export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "precache.worker.bcb2192b0116affaf38b.worker.js");
}
